export const AuthorName = ({ author }) => (
	<div>
		{
			author && author.canView && author.employeeId
				? <a href={ `/employees/employee.php?id=${ author.employeeId }` }>{ author.name }</a>
				: author.name
		}
	</div>
);
